import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components/macro';
import { propsUtils } from 'src/utils/index';
import {
  getBrandingColor, colorTypes, getBrandingStyleOverride, styleOverrides,
} from 'src/branding';
import { Cell, Row } from './Layout';

const cssActiveMixin = css`
  color: white;
  border-bottom: 2px solid ${getBrandingColor(colorTypes.primary)};
  margin-bottom: 0;
  background-color: ${getBrandingColor(colorTypes.primary)};
`;

const StyledTab = styled(Cell)`
  flex: 1 1 auto;
  cursor: pointer;
  line-height: 2.5;
  font-weight: bold;
  ${getBrandingStyleOverride(styleOverrides.boldText)};
  font-size: 1.2em;
  padding: 0 3em;
  margin: 0;
  background-color: ${getBrandingColor(colorTypes.whiteAltBg)};
  color: #4a4a4a;
  text-align: center;

  ${({ active }) => active && cssActiveMixin};
  :hover,
  :focus {
    background-color: #e6e6e6;
    ${({ active }) => active && cssActiveMixin};
  }

  :first-child {
    border-bottom-left-radius: 0.5em;
    border-top-left-radius: 0.5em;
  }
  :last-child {
    border-bottom-right-radius: 0.5em;
    border-top-right-radius: 0.5em;
  }

  @media screen and (max-width: 500px) {
    padding: 0 1em;
  }
`;

export const Tab = ({
  value, onClick, children, ...props
}) => (
  <StyledTab {...propsUtils.onClick(onClick)} {...props}>
    {children}
  </StyledTab>
);

const Tabs = ({
  value: valueProp, onChange, children, ...props
}) => {
  const [value, setValue] = useState(valueProp);

  useEffect(() => {
    if (onChange && value !== valueProp) {
      onChange(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    setValue(valueProp);
  }, [valueProp]);

  return (
    <Row grow {...props} style={{ maxWidth: '35em', ...props.style }}>
      {React.Children.map(children, (child, key) => React.cloneElement(child, {
        onClick:
            child.props.onClick
            || (() => {
              setValue(child.props.value || key);
            }),
        active: value === child.props.value || value === key,
      }))}
    </Row>
  );
};

export default Tabs;
